<template>
  <modal>
    <template v-slot:full>
      <div
        class="absolute top-0 left-0 w-full h-full text-white"
        :style="{
          'background-image': canton(user.cantonId).backgroundGradient
        }"
      >
        <layout>
          <box-unlock-title>
            <h1
              class="text-chplus-title-unlock uppercase text-glow leading-tight"
            >
              {{ $t("components.achievements.achievement.title") }}
            </h1>
            <div class="relative w-full h-0">
              <span
                class="absolute block w-full text-chplus-regular leading-tight"
              >
                <slot name="subtitle"></slot>
              </span>
            </div>
          </box-unlock-title>
          <div class="flex-grow w-full relative">
            <div
              ref="effect-area"
              class="absolute"
              style="top:50%;left:50%;transform: translate(-50%,-50%)"
            >
              <div class="relative w-full h-full">
                <div
                  class="absolute h-16 w-16 rounded-full bg-white glow"
                  style="top:50%;left:50%;transform: translate(-50%,-50%)"
                ></div>
                <img
                  class="absolute top-0 left-0 w-full h-full pulse"
                  src="@/assets/achievements/unlock-pro-backdrop-radial-prep.png"
                />
                <img
                  class="absolute top-0 left-0 w-full h-full"
                  src="@/assets/achievements/unlock-pro-backdrop-rough-prep.png"
                />
                <img
                  class="absolute top-0 left-0 w-full h-full"
                  src="@/assets/achievements/unlock-pro-backdrop-rings-prep.png"
                />
                <img
                  class="absolute top-0 left-0 w-full h-full rotate"
                  src="@/assets/achievements/unlock-pro-backdrop-spidericons-prep.png"
                />
                <slot name="icon"></slot>
              </div>
            </div>
          </div>

          <box-unlock-description>
            <span class="text-chplus-regular text-glow">
              <slot name="info-text"></slot>
            </span>
            <span class="text-chplus-title-unlock text-glow uppercase">
              <slot name="new-achievement-text"></slot>
            </span>
          </box-unlock-description>
          <box-unlock-bottom>
            <router-link :to="{ name: link }" class="mx-auto">
              <navigate-main-button>
                {{ $t("components.achievements.achievement.button_1") }}
              </navigate-main-button>
            </router-link>
          </box-unlock-bottom>
        </layout>
      </div>
    </template>
  </modal>
</template>

<script>
import { mapGetters } from "vuex";
import Layout from "../layouts/LayoutBase.vue";
import BoxUnlockTitle from "@/components/layouts/BoxUnlockTitle";
import BoxUnlockDescription from "@/components/layouts/BoxUnlockDescription";
import BoxUnlockBottom from "@/components/layouts/BoxUnlockBottom";
import NavigateMainButton from "@/components/buttons/NavigateMainButton";
import Modal from "@/components/layouts/Modal";

export default {
  name: "Achievement",
  components: {
    Modal,
    NavigateMainButton,
    BoxUnlockBottom,
    BoxUnlockDescription,
    BoxUnlockTitle,
    Layout
  },
  props: {
    link: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters("user", ["user"]),
    ...mapGetters("location", ["canton"])
  },
  created() {
    window.addEventListener("resize", this.onWindowResize);
  },
  mounted() {
    this.onWindowResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.onWindowResize);
  },
  methods: {
    onWindowResize() {
      const effectArea = this.$refs["effect-area"];
      const container = effectArea.parentNode;
      const containerStyle = getComputedStyle(container);

      const width = parseInt(containerStyle.width);
      const height = parseInt(containerStyle.height) * 0.87;

      const size = Math.min(width, height) + "px";
      effectArea.style.width = size;
      effectArea.style.height = size;
    }
  }
};
</script>

<style lang="scss" scoped>
.text-glow {
  text-shadow: 0 0 5px rgba(255, 238, 220, 0.75);
}

.glow {
  box-shadow: rgba(255, 238, 220, 0.5) 0 0 3.5rem 14rem;
}

.pulse {
  animation: pulse 3s infinite;
}

.rotate {
  animation: rotate 30s infinite linear;
  opacity: 0.5;
}

@keyframes pulse {
  0% {
    transform: scale(0.95);
  }

  50% {
    transform: scale(1);
  }

  100% {
    transform: scale(0.95);
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(359deg);
  }
}
</style>
